export const transitions = ['all .2s ease-in-out', 'all .4s ease-in-out']
export const borderRadius = `10px`
